import { Component, OnInit } from '@angular/core';
import { ITheme, Model } from 'survey-core';
import {surveyJson} from './surveyJson';
import { SurveyService } from './survey.service';
import { themeJson } from './theme';
//import "survey-core/defaultV2.min.css";
//import "survey-core/defaultV2.min.css";

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class SurveyComponent implements OnInit {
  model: Model;
  st:any;
  reqDefId:number;
  constructor(private surveyService: SurveyService) { }

  ngOnInit(): void {
   // const survey = new Model(surveyJson);
   this.reqDefId = 153;
   this.LoadJsonData();   
  }

  LoadJsonData() {
    try {     
      this.surveyService.GetRequestDefinitionJsonData(this.reqDefId).subscribe(data => {
       // this.resultData = data;
      // alert(data[0].jsonData);
       //console.log(data[0].jsonData)
      
       const surveyJson1 = data[0].jsonData;/*{
        elements: [{
          name: "FirstName",
          title: "Enter your first name:",
          type: "text"
        }, {
          name: "LastName",
          title: "Enter your last name:",
          type: "text"
        }]
      };*/

      const survey = new Model(surveyJson1);    
     // const survey = new Model(surveyJson);
     // const theme1: ITheme = themeJson;
      //const theme = themeJson as ITheme;
      //survey.applyTheme(themeJson1)
      //survey.applyTheme(themeJson);
      this.DisplayData(survey);
       this.model= survey;
      });
    }
    catch (e) {
      console.log(e);
    }
  }

  DisplayData(survey)
  {
    //const survey = new Model(surveyJsonDta);
    
    survey.onComplete.add((sender, options) => {
      this.st=JSON.stringify(sender.data, null, 3);
      alert(this.st);
     // alert(sender.data.FirstName)
    });
   // this.model= survey
  }

}
